import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-[calc(100vh-140px)] flex items-center justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "h-full flex relative"
}
const _hoisted_4 = { class: "w-full mt-[30px] mx-[20px]" }

import MainLayout from "@/layouts/MainLayout.vue";
import ProjectOverview from "@/components/Project/ProjectOverview.vue";
import { computed, onMounted, ref, watch } from "vue";
import client from "@/utils/axios";
import { useRoute } from "vue-router";
import { Project } from "@/types";
import { errorToast } from "@/utils/custom-toast";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import PhaseSidemenu from "@/components/Sidebar/Redesign/PhaseSidemenu.vue";
import SpinnerLoader from "@/components/Loaders/SpinnerLoader.vue";
import { useUserStore } from "@/stores/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDetails',
  setup(__props) {

const isLoading = ref(false);
const userStore = useUserStore();
let currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

const route = useRoute();
const id = route.params.id;
const projectDetails = ref<Project | null>(null);

// Fetch data
const getProjectDetails = async () => {
  isLoading.value = true;
  try {
    const response = await client.get(
      `/projects/${id}?sort_by=end&sort_order=desc&locale=${currentLanguage.value}`
    );
    projectDetails.value = response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      errorToast(error.response.data?.message);
    }
  } finally {
    isLoading.value = false;
  }
};
onMounted(() => {
  getProjectDetails();
});
//

const salesforceLink = computed(() => {
  if (projectDetails.value) {
    return `https://smalt.lightning.force.com/lightning/r/Phase__c/${projectDetails.value?.notionId}/view`;
  }
  return null;
});

watch(
  currentLanguage,
  async (newLang: any, oldLang: any) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getProjectDetails();
    }
  },
  { immediate: true }
);
watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: any, oldTimestamp: any) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getProjectDetails();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SecondaryPageHeader, {
          "project-details": projectDetails.value,
          "salesforce-link": salesforceLink.value
        }, null, 8, ["project-details", "salesforce-link"])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(SpinnerLoader)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (projectDetails.value)
              ? (_openBlock(), _createBlock(PhaseSidemenu, {
                  key: 0,
                  "project-details": projectDetails.value.phases
                }, null, 8, ["project-details"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(ProjectOverview, {
                "project-details": projectDetails.value,
                "is-loading": isLoading.value,
                onRefresh: getProjectDetails
              }, null, 8, ["project-details", "is-loading"])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})